import { inject, Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import {
  Firestore,
  collection,
  collectionData,
  query,
  where,
  orderBy,
  CollectionReference,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { QrTipo, QrValidez, Qr } from '../models/qr.model';

export type { QrTipo };

export interface CrearQrPayload {
  tipo:                QrTipo;
  nombreVisitante:     string;
  numeroAcompanantes:  number;
  validez:             QrValidez;
  expiraEnUTC?:        string;
}

export interface CrearQrResult {
  token: string;
  qrId:  string;
}

@Injectable({ providedIn: 'root' })
export class ResidenteQrService {
  private functions = inject(Functions);
  private firestore = inject(Firestore);

  async crearQR(payload: CrearQrPayload): Promise<CrearQrResult> {
    const fn = httpsCallable<CrearQrPayload, CrearQrResult>(
      this.functions, 'crearQR'
    );
    const result = await fn(payload);
    return result.data;
  }

  async cancelarQR(qrId: string): Promise<void> {
    const fn = httpsCallable<{ qrId: string }, { estado: string }>(
      this.functions, 'cancelarQR'
    );
    await fn({ qrId });
  }

  getMisQrs(residencialId: string, uid: string): Observable<Qr[]> {
    const col = collection(
      this.firestore,
      `residenciales/${residencialId}/qrs`
    ) as CollectionReference<Qr>;
    const q = query(
      col,
      where('generadoPorId', '==', uid),
      orderBy('creadoEn', 'desc')
    );
    return collectionData(q, { idField: 'id' }) as Observable<Qr[]>;
  }
}
